/**
 * @return {Promise<Object>}
 */
export const loadChartJs = () => import(
    /* webpackChunkName: "chartjs", webpackPreload: true */
    '~/lib/Chart.js/core.js'
).then(esm => esm.default);
